import { combineReducers } from 'redux'

import user from './user'
import factsheet from './factsheet'
import room from './room'
import preferences from './preferences'
import property from './property'
import notifications from './notifications'
import factConflict from './factConflict'

export default combineReducers({
  user,
  factsheet,
  room,
  preferences,
  property,
  notifications,
  factConflict
})
